import React, { useState } from "react";
import Navbar from "../components/Navbar";
import { BsTwitterX, BsInstagram, BsLinkedin } from "react-icons/bs";
import logo from "../assets/image 107.svg";
import { Link } from "react-router-dom";
import general from "../assets/general.png";

// import general from "../assets/general.png";
import patchup from "../assets/patchup.png";
import moveon from "../assets/moveon.png";
import compatibility from "../assets/compatibility.png";

import img1 from "../assets/sun-woman-beautiful-dating-outdoors.jpg";
import img2 from "../assets/3255915.jpg";
import img3 from "../assets/hands-man-woman-caught.jpg";


const blogCategories = {
  GENERAL: [
 {
  title: "Blog 1 - Team of Experts",
   img: general,
  description: `
How Combining a Team of Experts—Psychologists, Psychiatrists, and Dating Coaches—Provides the Best Relationship Solutions

Introduction

Modern relationships are complex. From emotional trauma to compatibility issues, people struggle with various challenges. But imagine a team of experts—psychologists, psychiatrists, and dating coaches—working together to provide holistic relationship solutions.

How Each Expert Helps

👨‍⚕️ Psychiatrist: Diagnoses and treats mental health conditions affecting relationships (e.g., anxiety, depression).

🧠 Psychologist: Provides therapy and counselling for emotional and behavioral issues.

💑 Dating Coach: Offers practical advice on attraction, communication, and long-term compatibility.

Why a Multi-Expert Approach Works Best

✅ Complete Mental & Emotional Well-being – A psychiatrist can address mental health, a psychologist can guide emotions, and a dating coach can improve dating skills.

✅ Personalized Relationship Strategies – Different professionals provide unique insights based on individual needs.

✅ Better Long-Term Relationship Success – Combining therapy, coaching, and mental health support creates a strong foundation for relationships.

Conclusion

Instead of relying on one expert, imagine a team working together to solve your relationship problems! Whether you're dealing with breakup depression, dating struggles, or marriage conflicts, a comprehensive approach ensures the best relationship solutions.
`,
},

 {
  title: "Blog 2 -Why Divorce Cases Are Rising in India",
   img: general,
  description: `
Introduction

In recent years, India has witnessed a significant rise in divorce cases. Once considered taboo, divorce is now becoming more common, especially among younger couples. But why are so many marriages ending in separation?

Reasons Behind the Rising Divorce Rate in India

1. Unrealistic Expectations from Marriage

• Many couples expect a perfect love story and struggle when reality hits.

• Bollywood and social media create unrealistic romantic ideals, leading to disappointment.

2. Lack of Compatibility & Communication Issues

• Many arranged marriages happen without understanding compatibility.

• Miscommunication and emotional distance lead to conflicts.

3. Changing Social Norms & Financial Independence

• Society is slowly accepting that divorce is better than staying in a toxic relationship.

• Women today are more financially independent and no longer feel forced to stay in unhappy marriages.

4. Infidelity & Trust Issues

• Increased exposure to social media and dating apps has made cheating easier.

• Emotional and physical infidelity has become a major reason for divorces.

5. Mental Health Issues & Stress

• Depression, anxiety, and work stress take a toll on marriages.

• Many couples hesitate to seek relationship counselling or therapy until it’s too late.

Conclusion

Divorce rates in India are rising due to modern relationship challenges, changing mindsets, and lack of compatibility. Seeking pre-marital counselling and relationship therapy can help couples avoid future separations.
`,
},
  {
  title: "Blog 3 - Arrange vs. Love Marriage – What Does Indian Youth Prefer?",
   img: general,
  description: `
Introduction

In India, marriage is more than just a personal decision—it’s a cultural and societal expectation. While love marriages have gained acceptance, arranged marriages are still the norm. So, what do Indian youth prefer today?

Advantages & Disadvantages of Love and Arranged Marriage

Love Marriage:

✅ Freedom to choose a partner based on personal connection.

✅ Better understanding and emotional compatibility before marriage.

❌ Family pressure and lack of support can create stress.

❌ More chances of conflicts if expectations don't match reality.

Arranged Marriage:

✅ Parents ensure compatibility in background, values, and families.

✅ Less emotional pressure to make decisions alone.

❌ Lack of prior emotional connection can lead to adjustment struggles.

❌ Families may pressure couples to stay in unhappy marriages.

Conclusion

While love marriages focus on emotional compatibility, arranged marriages prioritize family and cultural aspects. Indian youth today prefer a mix—choosing their own partner with family involvement.
`,
},

  {
  title: "Blog 4 - Psychologist vs. Therapist : Whom to Consult?",
   img: general,
  description: `
Introduction

People often hesitate to seek professional help because they are unsure whether to see a psychologist, therapist, or counsellor for marriage issues. Understanding their roles can help you make the right choice.

Key Professionals in Mental Health & Relationships

Psychologist

• Degree/Training: Master's or PhD/PsyD in Psychology

• Expertise: Mental health assessment, therapy, research

• When to See: For therapy, psychological testing, managing mental health and relationship issues.

Psychiatrist

• Degree/Training: Medical Doctor (MD) + Psychiatry specialization

• Expertise: Can diagnose mental illness and prescribe medication

• When to See: For severe mental illness needing medication (e.g., bipolar disorder, schizophrenia).

Therapist

• Degree/Training: Often licensed counsellors or psychologists

• Expertise: Talk therapy for emotional, mental, and relationship issues

• When to See: For ongoing counselling and therapy support.

Counsellor

• Degree/Training: Master's in Counselling or related field

• Expertise: Support and guidance for life, stress, and relationships

• When to See: For personal growth, coping strategies, and mild to moderate issues.

Dating Coach

• Degree/Training: No specific degree, training varies

• Expertise: Coaching on dating skills, confidence, and social interaction

• When to See: For help with dating strategies, confidence, and social skills.

Life Coach

• Degree/Training: Certification programs (varies widely)

• Expertise: Guidance on life goals, motivation, and habits

• When to See: For general life improvement, goal setting, career or relationship advice.

Whom to Meet for What?

• Feeling anxious, depressed, or experiencing mental health issues?

Meet a psychologist or psychiatrist (if medication is needed).

• Want therapy or counselling for relationship problems, stress, or emotional challenges?

See a therapist or counsellor.

• Struggling with couple or family conflicts?

Look for a marriage and family therapist or a psychologist specializing in relationships.

• Need help improving your dating life or social confidence?

A dating coach can help with practical tips and confidence-building.

• Want to improve overall life goals, motivation, or habits?

A life coach can guide you.

Patch Up has the entire roster under one roof—so you don’t have to worry about whether you have connected to the right expert for your problems.
`,
},
{
  title: "Blog 5 - Apologizing After a Breakup: What Experts Say",
  img: general,
  description: `
Introduction

After a breakup, guilt and regret often arise. Apologizing can bring closure, but it must be done the right way to avoid reopening wounds or making things worse.

When Should You Apologize?

✔ If you genuinely hurt your ex-partner and regret your actions.

✔ If the breakup ended on bad terms and you want to make peace.

✔ If you want closure – not to rekindle the relationship, but to heal.

How to Apologize the Right Way

✔ Be Honest & Sincere – Avoid blaming the other person.

✔ Accept Responsibility – Acknowledge your mistakes without justifying them.

✔ Give Space After Apologizing – Don’t expect immediate forgiveness or reconciliation.

When Not to Apologize

❌ If you’re only apologizing to get them back.

❌ If they asked for no contact – Respect their boundaries.

❌ If the relationship was abusive or extremely toxic.

Conclusion

A sincere apology can provide closure and emotional healing. However, it should be given with the right intention. Relationship counselling can help navigate post-breakup emotions in a healthy way.
`,
},
{
  title: "Blog 6 - How Toxic Relationships Affect Mental Health: A Counsellor’s Take",
  img: general,
  description: `
Introduction

A toxic relationship can drain you emotionally, mentally, and even physically. If your relationship is filled with constant criticism, manipulation, or emotional abuse, it can lead to anxiety, depression, and low self-esteem.

Signs of a Toxic Relationship

❌ Emotional abuse – Constant belittling or criticism.

❌ Manipulation – Guilt-tripping or gaslighting.

❌ Extreme jealousy & control – Restricting independence.

❌ Feeling mentally exhausted & anxious.

How Counselling Helps

• Identifies toxic patterns.

• Provides strategies to set healthy boundaries.

• Helps with healing and self-worth restoration.

Conclusion

Toxic relationships damage mental health. Seeking therapy can help break free from toxicity and rebuild emotional well-being.
`,
},
],

  "PATCH UP": [
  {
  title: "Blog 1 - Signs You Are Not Happy in a Relationship",
  img: patchup,
  description: `
Introduction

Every relationship has ups and downs, but when unhappiness becomes a constant feeling, it’s time to evaluate your relationship. Many people stay in unhappy relationships due to fear of loneliness, societal pressure, or emotional attachment. However, ignoring these signs can lead to depression, resentment, and even breakups. Relationship counselling and therapy can help individuals understand their emotions and decide the best course of action.

Signs You Might Be Unhappy in Your Relationship

1. Constant Arguments & Miscommunication

• Do you and your partner fight over small issues?

• Are your conversations filled with misunderstandings and blame?

• Do you avoid discussing important matters out of fear of conflict?

2. Feeling Lonely Even When Together

If you feel emotionally disconnected from your boyfriend, girlfriend, husband, or wife, it’s a red flag. A healthy relationship should provide companionship, not loneliness.

3. Lack of Physical or Emotional Intimacy

• Has your relationship become routine with no affection or effort?

• Do you feel emotionally distant from your partner?

• Do you crave affection that is no longer there?

4. Thinking About Breaking Up Frequently

• Have you imagined life without your partner and felt relief?

• Do you stay in the relationship out of habit rather than love?

5. Loss of Respect & Admiration

If you no longer respect your partner’s opinions, choices, or behavior, it can create resentment and dissatisfaction in the relationship.

How Relationship Counselling Can Help

A relationship psychologist, therapist, or online counsellor can help you:

✔ Identify the root cause of your unhappiness.

✔ Improve communication and rebuild emotional intimacy.

✔ Decide whether to fix the relationship or move on.

Conclusion

Ignoring unhappiness in a relationship can lead to emotional damage and stress. If you relate to these signs, consider seeking help from a relationship therapist or online counselling expert to find clarity and a solution.
`,
},
  {
  title: "Blog 2 - How Relationship Therapy Can Save Your Marriage",
  img: patchup,
  description: `
Introduction

Marriage is a journey filled with love, companionship, and challenges. However, unresolved conflicts, communication gaps, and emotional disconnection can push a marriage to the brink of divorce. Relationship therapy can help couples rebuild trust, improve communication, and restore intimacy, ultimately saving their marriage.

Signs Your Marriage Needs Therapy

✔ Constant Fights & Misunderstandings – Arguments become frequent, and communication turns negative.

✔ Emotional or Physical Distance – Feeling lonely even when together is a major red flag.

✔ Loss of Trust – Infidelity, secrecy, or repeated betrayals damage a marriage.

✔ Thinking About Separation – If you constantly wonder whether to leave, therapy can provide clarity.

How Therapy Can Save Your Marriage

🔹 Improves Communication – A therapist helps couples express emotions healthily.

🔹 Rebuilds Trust & Emotional Intimacy – Therapy provides tools to restore closeness.

🔹 Teaches Conflict Resolution – Couples learn to resolve issues without fights.

🔹 Helps Decide If the Marriage is Worth Saving – A therapist offers an objective perspective.

Conclusion

Every marriage faces struggles, but relationship counselling can provide the guidance needed to heal and strengthen your bond. If your marriage feels troubled, seeking professional help could be the best decision you make.
`,
},
  {
  title: "Blog 3 - How to Bring Back the Spark in a Relationship",
  img: patchup,
  description: `
Introduction

Over time, relationships can lose their excitement and passion. Work stress, routine life, and lack of effort can turn a once-exciting relationship into a dull one. However, it’s possible to rekindle the spark and rebuild intimacy with the right strategies.

Ways to Reignite Passion in Your Relationship

1. Prioritize Quality Time Together

• Go on regular date nights and surprise each other.

• Travel or take a short trip to break the routine.

• Spend tech-free time together to reconnect emotionally.

2. Communicate Openly & Honestly

• Share your feelings, fears, and desires without hesitation.

• Listen to your partner’s concerns and show empathy.

3. Try New Experiences Together

• Take up a hobby as a couple (dance, cooking, adventure sports).

• Introduce small romantic gestures—love notes, surprise gifts, or breakfast in bed.

4. Work on Physical Intimacy

• Rekindle intimacy by exploring each other’s love languages.

• Express affection through touch, hugs, and small gestures of love.

5. Seek Relationship Therapy If Needed

A relationship psychologist or therapist can help couples rediscover their emotional and physical connection through guided counselling sessions.

Conclusion

Every relationship requires effort to keep the spark alive. If you feel disconnected, counselling, self-awareness, and mutual efforts can help bring back the lost magic.
`,
},
  {
  title: "Blog 4 - Compatibility Issues in Marriage: How Counselling Can Help You Connect",
  img: patchup,
  description: `
Introduction

Compatibility issues can create cracks in even the most loving marriages. Differences in values, expectations, and personalities can lead to conflicts and emotional detachment. Marriage counselling can bridge these gaps and help couples reconnect.

Common Compatibility Issues

❌ Different life goals – Career vs. family priorities.

❌ Financial conflicts – Different spending or saving habits.

❌ Opposing parenting styles.

❌ Lack of emotional or physical intimacy.

How Counselling Helps

✔ Improves Understanding – Helps couples understand each other’s perspective.

✔ Teaches Conflict Resolution – Provides tools for healthy discussions.

✔ Bridges Emotional Gaps – Helps partners reconnect emotionally and physically.

Conclusion

A happy marriage isn’t about being identical—it’s about learning to grow together despite differences. Compatibility counselling can strengthen your bond and improve marital happiness.
`,
},
  {
  title: "Blog 5 - Patch Up or Move On? A Counsellor's Perspective",
  img: patchup,
  description: `
Introduction

After a breakup, it's natural to wonder if getting back with your ex is the right choice. You may miss them, feel lonely, or believe things could be different this time. However, reconciliation isn’t always the best option. Relationship counsellors, psychologists, and therapists often stress the importance of evaluating whether reuniting is truly healthy.

You can Patch Up if:

✅ You Both Have Grown Emotionally – Have you and your ex worked on personal growth and emotional intelligence?

✅ The Breakup Was Due to Circumstances, Not Toxicity – Was it distance, career, or timing rather than disrespect or manipulation?

✅ You Have Resolved Past Issues – Have the problems that led to the breakup been addressed through counselling or honest communication?

✅ There’s Genuine Love & Respect – Is your connection based on deep understanding rather than loneliness?

You should Move On if:

❌ The Relationship Was Toxic – If there was emotional abuse, constant fights, or manipulation, a breakup was necessary for your well-being.

❌ You’re Lonely, Not in Love – Missing someone doesn’t mean they are right for you. A psychologist can help you navigate post-breakup loneliness.

❌ They Haven't Changed – If your ex still exhibits the same unhealthy behaviors, expect the same outcome.

❌ You’re Ignoring Your Own Growth – Getting back together should enhance your life, not set you back.

How Counselling Can Help You Decide

A relationship counsellor or therapist can:

• Provide an unbiased perspective on your situation.

• Help you identify toxic patterns in your past relationship.

• Guide you on whether reconciliation is a healthy choice.

Conclusion

Before making a decision, ask yourself: “Am I going back because I love them, or because I fear being alone?” If you’re confused, seeking relationship therapy can provide clarity. Your happiness and emotional health should always come first.
`,
},
],

"MOVE ON": [
 {
  title: "Blog 1 - How to Move On After a Breakup: Expert Counselling Tips",
  img: moveon,
  description: `
Introduction

Breakups are emotionally challenging, leaving you with sadness, confusion, and sometimes even depression. Whether you’ve broken up with a boyfriend, girlfriend, husband, or wife, the pain can feel unbearable. However, moving on is possible with the right mindset and guidance. Relationship counselling, therapy, and expert advice can help you heal and build a stronger future.

Why Moving On is Difficult

Breakups affect both your emotional and mental well-being. You might experience:

• Sadness and loneliness

• Overthinking and self-doubt

• Anxiety about the future

• Depression and withdrawal from social life

• A desire to reconcile, even when the relationship was toxic

But remember: moving on doesn’t mean forgetting—it means finding peace and growing from the experience.

Expert-Recommended Steps to Move On from a Breakup

1. Accept Your Emotions and Allow Yourself to Grieve

Suppressing emotions only prolongs the healing process. It’s okay to feel sad, cry, and express your emotions. A relationship therapist or psychologist can help you process these feelings in a healthy way.

2. Cut Off Unhealthy Contact with Your Ex

Keeping in touch with your ex can make it harder to heal. Consider:

✔️ Unfollowing on social media to avoid constant reminders.

✔️ Avoiding late-night texting or calls out of loneliness.

✔️ Setting boundaries if you work together or share mutual friends.

3. Seek Professional Help if Needed

If you’re feeling overwhelmed, online counselling with a psychologist or therapist can provide coping strategies. Therapy can help if you’re experiencing:

• Breakup depression

• Constant sadness or lack of motivation

• Difficulty focusing on daily tasks

4. Focus on Self-Growth

A breakup is an opportunity for self-improvement. Try:

✔️ Fitness and physical activities – Exercise releases endorphins, improving your mood.

✔️ New hobbies – Learning something new distracts your mind and boosts confidence.

✔️ Journaling your thoughts – Writing helps process emotions and track progress.

5. Surround Yourself with Positive People

Spending time with supportive friends and family can remind you of your worth. If needed, consider group therapy or relationship counselling to discuss your feelings.

6. Avoid Rebound Relationships

Jumping into a new relationship too soon might not be the best idea. Take time to heal, understand yourself, and set healthy relationship expectations.

7. Redefine Your Future Goals

This is a chance to focus on career, travel, or personal aspirations without compromise. A relationship therapist can help you set goals and rebuild confidence.

Conclusion

Moving on after a breakup is a journey, not a race. With therapy, self-care, and support from relationship experts, you can heal and emerge stronger. If you’re struggling, don’t hesitate to seek online counselling from a psychologist or therapist—professional help can make all the difference.
`,
},
  {
  title: "Blog 2 - Why Breakups Hurt So Much? Here's How Therapy Can Help?",
  img: moveon,
  description: `
Introduction

A breakup can leave you feeling emotionally shattered, sad, and even depressed. Whether it was a long-term relationship or a short fling, the emotional pain is real. Many people struggle with loneliness, self-doubt, and overwhelming sadness. Relationship counselling and therapy can help you heal and regain control over your emotions.

Why Does a Breakup Feel So Devastating?

💔 Emotional Bonding is Disrupted – The brain releases oxytocin (bonding hormone) in relationships. A breakup can feel like withdrawal from an addiction.

💔 Loss of Future Plans – You grieve not only the person but the future you imagined together.

💔 Attachment & Fear of Loneliness – Long-term relationships create deep emotional attachments, making separation extremely difficult.

💔 Emotional Trauma – Feeling abandoned, betrayed, or unworthy.

💔 Sadness & Depression – Losing interest in daily activities.

💔 Overthinking & Guilt – Questioning what went wrong and blaming yourself.

How Therapy Helps You Heal After a Breakup

1. Understanding & Processing Your Emotions

A relationship counsellor, psychologist, or therapist provides a safe space to express your pain, anger, and frustration. They help you:

• Acknowledge your emotions without judgment.

• Understand why you're feeling this way.

• Develop a positive mindset toward healing.

2. Overcoming Breakup Depression

Breakups can trigger clinical depression in some individuals. A psychiatrist or psychologist can diagnose and treat depression if you experience:

• Persistent sadness lasting weeks or months.

• Lack of motivation to work, socialize, or even get out of bed.

• Suicidal thoughts or feelings of hopelessness.

Online therapy is an accessible option for those who find it hard to visit a clinic.

3. Learning Healthy Coping Mechanisms

Instead of self-destructive behaviors like excessive drinking, unhealthy eating, or rebounding, therapy teaches:

✔️ Mindfulness & meditation to calm your mind.

✔️ Journaling to release emotional baggage.

✔️ Exercise & healthy habits to improve mental well-being.

4. Rebuilding Self-Esteem & Confidence

Breakups often make people feel “not good enough.” A therapist helps rebuild your self-worth by:

• Identifying toxic relationship patterns.

• Teaching self-love and acceptance.

• Encouraging personal growth and future goals.

5. Helping You Move On & Open Up to Love Again

A breakup doesn’t mean you’ll never find love again. Therapy guides you through:

✔️ Letting go of the past without resentment.

✔️ Understanding what you truly need in a partner.

✔️ Entering future relationships with confidence and emotional stability.

Conclusion

If you’re struggling with sadness, depression, or confusion after a breakup, therapy can be life-changing. Seeking help from a relationship counsellor, psychologist, or online therapist can help you heal faster and move forward with a positive outlook. You deserve happiness—don’t be afraid to reach out for help.
`,
},
  {
  title: "Blog 3 - Breakup Depression and Breakup Anxiety - A Brief Explanation",
  img: moveon,
  description: `
Introduction

A breakup can be emotionally devastating, often leading to:

Breakup depression – Characterized by deep sadness, loss of motivation, and withdrawal from daily life.

Breakup anxiety – Characterized by sleepless nights, obsessive thoughts, and fear of being alone.

Symptoms of Breakup Depression

❌ Persistent sadness and hopelessness that lasts for weeks or months.

❌ Loss of interest in activities you once enjoyed.

❌ Difficulty sleeping or excessive sleep.

❌ Constant overthinking about the past relationship.

❌ Feeling isolated and withdrawn.

How Online Therapy Helps

✔️ Convenient & Accessible – Get professional help from the comfort of your home.

✔️ Guidance from a Licensed Psychologist – Learn coping strategies tailored to your situation.

✔️ Emotional Support – Helps you process your emotions and regain self-confidence.

Symptoms of Breakup Anxiety

❌ Overthinking about the ex-partner and relationship mistakes.

❌ Panic attacks or extreme sadness.

❌ Constantly checking their social media.

❌ Fear of never finding love again.

How Online Counselling Helps

✔️ Provides Coping Strategies – Learn to manage emotions effectively.

✔️ Helps You Move On Healthily – Prevents self-destructive behavior.

✔️ Builds Self-Worth & Confidence – Encourages personal growth.

Conclusion

Both breakup depression and breakup anxiety can feel overwhelming, but therapy provides support to help you heal and move forward with confidence.
`,
},
  {
  title: "Blog 4 - Dealing with Relationship Trauma: When to Seek Professional Help",
  img: moveon,
  description: `
Introduction

Toxic relationships, emotional abuse, and painful breakups can leave behind relationship trauma that affects future relationships and mental well-being. Seeking professional help from a relationship therapist, psychologist, or psychiatrist can help you heal.

Signs You Need Professional Help

❌ Fear of Commitment – Avoiding relationships due to past hurt.

❌ Constant Anxiety in Relationships – Overthinking and expecting the worst.

❌ Trust Issues – Difficulty trusting new partners.

❌ Flashbacks or Emotional Pain – Reliving past hurt constantly.

How Therapy Helps

✔️ Healing from Emotional Scars – Learn to process pain in a healthy way.

✔️ Breaking Negative Patterns – Avoid repeating toxic relationship behaviors.

✔️ Regaining Trust & Self-Love – Builds emotional strength and confidence.

Conclusion

If past relationship trauma is affecting your present, seeking professional therapy can help you move forward positively.
`,
},
  {
  title: "Blog 5 - Rebuilding Trust After a Conflict",
  img: moveon,
  description: `
Introduction

Trust is the foundation of any relationship, and once broken, it’s difficult to rebuild. Whether due to infidelity, betrayal, or constant dishonesty, trust issues can destroy relationships. However, with counselling and conscious effort, trust can be restored.

Steps to Rebuild Trust

✔️ Take Responsibility – The person who broke the trust must take accountability.

✔️ Open & Honest Communication – Transparency is key to rebuilding trust.

✔️ Time & Patience – Healing and forgiveness take time.

✔️ Seek Professional Help – A relationship therapist can guide the process.

Conclusion

Rebuilding trust after a breakup or marriage conflict is challenging but possible with counselling, effort, and genuine change. If trust has been broken in your relationship, seeking professional guidance can make the journey smoother.
`,
},
],

COMPATIBILITY: [
  {
  title: "Blog 1 - Why Compatibility Check is Important Before Marriage",
  img: compatibility,
  description: `
Introduction

Marriage is a lifelong commitment, and ensuring compatibility with your partner is crucial before taking the big step. Many relationships fail not because of a lack of love but due to fundamental incompatibilities in values, goals, and emotional needs. A compatibility check before marriage through relationship counselling can save couples from future heartbreak, conflicts, and even divorce.

What is Compatibility in a Relationship?

Compatibility goes beyond attraction—it involves emotional, intellectual, and lifestyle alignment between partners. Some key areas to assess include:

• Emotional Compatibility: How well do you handle conflicts and express emotions?

• Value System: Do your beliefs about family, career, and life align?

• Communication Style: Can you have open, healthy conversations without misunderstandings?

• Financial Outlook: Do you share similar financial habits and goals?

• Future Aspirations: Are you aligned on having children, career growth, or where to live?

Why Compatibility Matters Before Marriage

1. Prevents Future Conflicts

Many marital issues stem from unresolved differences in expectations. A pre-marriage compatibility check helps address potential problem areas early on.

2. Helps in Understanding Emotional & Mental Health Needs

Not all partners have the same way of expressing love or dealing with stress. Relationship counselling with a psychologist or therapist can help identify how emotionally compatible you are with your partner.

3. Strengthens the Relationship Foundation

A strong foundation ensures that when challenges arise, couples know how to work through them rather than giving up. Compatibility checks provide tools to build a deeper connection.

4. Reduces the Risk of Divorce

With India seeing a rise in divorce rates, understanding whether you and your partner are truly meant for each other can prevent future heartbreak and legal battles.

5. Enhances Communication & Conflict Resolution Skills

A therapist or counsellor can guide couples on how to effectively handle disagreements, preventing unnecessary fights and misunderstandings.

How to Check Compatibility Before Marriage

• Take Professional Relationship Counselling: Consulting an online relationship expert, psychologist, or therapist can help assess compatibility.

• Have Deep Conversations: Discuss expectations on finances, family, career, and values.

• Understand Love Languages: Knowing how your partner gives and receives love improves emotional bonding.

• Take Compatibility Tests: Many psychologists and relationship experts offer structured tests to measure compatibility.

Conclusion

Marriage is a beautiful journey, but ensuring compatibility before tying the knot can make all the difference. Relationship counselling, guided by experts such as psychologists and therapists, provides clarity and prevents future distress. If you're considering marriage, take a step toward a happy future by investing in a compatibility check today!
`,
},

  {
  title: "Blog 2 - How to Choose the Right Life Partner Among Thousands of Matches on Matrimonial Sites",
  img: compatibility,
  description: `
Introduction

With thousands of profiles on matrimonial sites, choosing the right life partner can be overwhelming. A perfect match isn’t just about looks—it’s about compatibility, values, and long-term understanding.

Steps to Find the Right Match Online

1. Define Your Priorities & Non-Negotiables

• Is mother tongue, religious or cultural background important?

• Are you comfortable with their lifestyle – smoking/drinking, work that requires travel?

2. Look Beyond Physical Appearance

• Attraction is important, but values, personality, and compatibility matter more.

3. Have Honest Conversations Early On

• Discuss expectations about career, family roles, children, and financial planning.

4. Use Relationship Counselling for Clarity

• Many psychologists and therapists offer compatibility counselling before marriage.

Conclusion

Choosing the right partner is a balance of logic, emotions, and compatibility. Seeking expert counselling can help you make an informed decision.
`,
},
  {
  title: "Blog 3 - How to Build a Strong Relationship with Compatibility Counselling",
  img: compatibility,
  description: `
Introduction

A strong, long-lasting relationship is built on compatibility, trust, and communication. However, many couples struggle due to mismatched expectations and differences. Compatibility counselling helps partners understand each other better and build a healthy relationship.

How Compatibility Counselling Strengthens Relationships

✔ Identifies Core Relationship Values – Helps couples align life goals and expectations.

✔ Enhances Emotional & Physical Intimacy – Helps partners connect at a deeper level.

✔ Improves Communication – Teaches conflict resolution techniques.

✔ Prepares Couples for Marriage – Ensures a solid foundation before committing.

Who Should Consider Compatibility Counselling?

• Couples planning to get married.

• Newly engaged couples.

• Married couples facing recurring conflicts.

• Individuals who want to evaluate compatibility before making a lifelong commitment.

• Partners looking to strengthen communication and emotional understanding.

Benefits of Seeking Professional Guidance

• Gain clarity about relationship expectations.

• Learn healthy communication techniques.

• Resolve misunderstandings before they become major conflicts.

• Build trust, respect, and emotional security.

• Create a stronger and happier future together.

Conclusion

Whether you're dating, engaged, or married, compatibility counselling can help strengthen your bond and create a fulfilling relationship. By understanding each other's personalities, values, and future goals, couples can build a lasting relationship based on trust, respect, and mutual understanding.
`,
},
],
};


const customStyles = {
  control: (base, state) => ({
    ...base,
    border: state.isFocused ? "1px solid #cc2b52" : "1px solid #cc2b52",
    boxShadow: state.isFocused ? "0 0 3px #cc2b52" : "none", // Light red shadow
    "&:hover": {
      border: "1px solid #cc2b52",
    },
  }),
  option: (base, { isSelected }) => ({
    ...base,
    color: isSelected ? "white" : "#cc2b52",
    backgroundColor: isSelected ? "#cc2b52" : "white",
    "&:hover": {
      backgroundColor: "rgba(255, 0, 0, 0.1)",
    },
  }),
  singleValue: (base) => ({
    ...base,
    color: "#cc2b52",
  }),
};

const Blogs = () => {
  const [openCategory, setOpenCategory] = useState(null);
  const [selectedBlog, setSelectedBlog] = useState(null);

  return (
    <div
      className="d-flex flex-column"
      style={{ backgroundColor: "#f7ebee", minHeight: "100vh" }}
    >
      <Navbar />

      <div className="container privacy-top-margin py-4">
        <h1 style={{ color: "#CC2B52" }}>Blogs</h1>

        <h2
          className="mt-3 mb-4"
          style={{ color: "#6E6E6E" }}
        >
          
        </h2>
<div className="d-flex gap-3 flex-wrap mb-4">
  {Object.keys(blogCategories).map((category) => (
    <button
      key={category}
      onMouseEnter={() => setOpenCategory(category)}
      className={`blog-tab ${
        openCategory === category ? "active-blog-tab" : ""
      }`}
    >
      {category}
    </button>
  ))}
</div>

{openCategory && (
  <div
    style={{
      background: "#fff",
      borderRadius: "15px",
      overflow: "hidden",
      marginBottom: "30px",
    }}
  >
    {blogCategories[openCategory].map((blog, index) => (
      <div
        key={index}
        onClick={() => setSelectedBlog(blog)}
        style={{
          padding: "18px 24px",
          cursor: "pointer",
          borderBottom: "1px solid #f1f1f1",
          transition: "0.3s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#fdf2f5";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "#fff";
        }}
      >
        <span
          style={{
            color: "#333",
            fontSize: "16px",
            fontWeight: "600",
          }}
        >
          {blog.title}
        </span>
      </div>
    ))}
  </div>
)}

        {selectedBlog && (
          <div
            className="mt-4"
            style={{
              background: "#fff",
              borderRadius: "15px",
              overflow: "hidden",
            }}
          >
            <img
              className="blogImage"
  src={selectedBlog.img}
  alt={selectedBlog.title}
              style={{
                width: "100%",
                height: "450px",
                objectFit: "cover",
              }}
            />

           <div className="p-4">
  <h2 style={{ color: "#CC2B52" }}>
    {selectedBlog.title}
  </h2>

<div
  style={{
    color: "#4A4A4A",
    fontSize: "17px",
    lineHeight: "32px",
    fontFamily: "DM Sans",
    whiteSpace: "pre-line",
    textAlign: "justify",
  }}
>
  {selectedBlog.description}
</div>
</div>
          </div>
        )}
      </div>


      {/* Footer */}
      <div className="mt-5 pt-5 container pb-3">
        <div className="d-flex justify-content-between align-items-center">
          <img src={logo} alt="Logo" 
          />
          <div className="d-flex gap-3">
            <BsTwitterX style={{ color: "#CC2B52" }} />
            <BsLinkedin style={{ color: "#CC2B52" }} />
            <BsInstagram style={{ color: "#CC2B52" }} />
          </div>
        </div>
        <hr />
        <div className="d-flex justify-content-between">
          <div className="d-flex gap-3">
            <span style={{ color: "#3B486E99", fontSize: "16px" }}>
              © Patchup 2025
            </span>
            <Link to="/privacy-policy" style={{ textDecoration: "none" }}>
              <span
                style={{
                  color: "#3B486E",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Privacy Policy
              </span>
            </Link>
            <Link to="/terms-and-conditions" style={{ textDecoration: "none" }}>
              <span
                style={{
                  color: "#3B486E",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Terms of use
              </span>
            </Link>
          </div>
          <div>
            <span
              style={{ color: "#3B486E", fontSize: "16px", fontWeight: "600" }}
            >
              Support@patchup.com
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blogs;
